import { render, staticRenderFns } from "./NameScreenScore.vue?vue&type=template&id=9766b996"
import script from "./NameScreenScore.vue?vue&type=script&lang=js"
export * from "./NameScreenScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports